import { Schema } from "@effect/schema";
import { Address, ADDRESS_ZERO } from "../address";
import {
  DashboardMarketAsset,
  SKELETON_DASHBOARD_MARKET_ASSET,
} from "../market-asset/dashboard-market-asset";
import { MarketUserState } from "./market-user-state";
import { Usd, USD_ONE, USD_ZERO } from "../usd";
import { SKELETON_TOKEN_SYMBOL } from "../token";
import { PERCENT_ONE_HUNDRED, PERCENT_ZERO } from "../percent";
import { makeAmount } from "../amount";
import produce from "immer";

export type DashboardMarket = typeof DashboardMarket.Type;
export type DashboardMarketEncoded = typeof DashboardMarket.Encoded;

export const DashboardMarket = Schema.Struct({
  // market meta
  marketAddress: Address,
  marketSymbol: Schema.String,
  isDeprecated: Schema.Boolean,
  isPaused: Schema.Boolean,

  // user market state
  ...MarketUserState.fields,

  depositBalanceUsd: Usd,
  debtBalanceUsd: Usd,

  // assets
  baseAsset: DashboardMarketAsset,
  bridgeAssets: Schema.Tuple(
    DashboardMarketAsset,
    Schema.optionalElement(DashboardMarketAsset)
  ),
}).annotations({ identifier: "DashboardMarket" });

/**
 * The skeleton dashboard market has 1 collateral deposit
 */
export const SKELETON_DASHBOARD_MARKET: DashboardMarket = {
  marketAddress: ADDRESS_ZERO,
  marketSymbol: SKELETON_TOKEN_SYMBOL,
  isDeprecated: false,
  isPaused: false,

  userLtv: PERCENT_ZERO,
  userLiquidationThreshold: PERCENT_ZERO,
  healthFactor: PERCENT_ONE_HUNDRED,
  borrowingPowerUsed: PERCENT_ZERO,
  isAtRiskOfLiquidation: false,

  depositBalanceUsd: USD_ONE,
  debtBalanceUsd: USD_ZERO,

  baseAsset: produce(SKELETON_DASHBOARD_MARKET_ASSET, (draft) => {
    (draft.collateralBalance = makeAmount(10n ** 18n)),
      (draft.collateralBalanceUsd = USD_ONE);
    draft.depositBalanceUsd = USD_ONE;
  }),

  bridgeAssets: [
    SKELETON_DASHBOARD_MARKET_ASSET,
    SKELETON_DASHBOARD_MARKET_ASSET,
  ],
};
